<header id="headadmin">
    <app-header></app-header>
    <app-navbar></app-navbar>
</header>
<body>
    <div class="card">
        <div class="card-header" style="background-color: #be0c4d;">
            <h5 style="color: white;">Colsulta Reporte</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col">
                  <p>Seleccionar tipo de consulta : </p>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">Anual</div>
                    <div class="col"><input class="form-check-input" type="checkbox" value="true" id="si" (change)="SeleccionPeriodo()"
                        [disabled]="AnualDis" [(ngModel)]="Anual"></div><!--[(ngModel)]="ReporPedRefSi"-->
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div *ngIf="TipoFuente=='CHV'" class="col">Trimestral</div>
                    <div *ngIf="TipoFuente=='FIVI'" class="col">Mensual</div>
                    <div class="col"><input class="form-check-input" type="checkbox" value="false" id="no" (change)="SeleccionPeriodo()"
                        [disabled]="TrimestreDis" [(ngModel)]="Trimestre"></div><!---->
                  </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Vigencia :</label>
                </div>
                <div class="col-3">
                    <select class="form-select" aria-label="Default select example" name="anio" [(ngModel)]="Consultar.anio">
                        <option  value="0" selected="selected">Seleccione</option>
                        <option *ngFor="let anio of Anios" value="{{anio.anio}}">{{anio.anio}}</option>
                    </select>
                </div>
                <div class="col">
                    <label *ngIf="TipoFuente=='CHV'">Trimestre :</label>
                    <label *ngIf="TipoFuente=='FIVI'">Mensual :</label>
                </div>
                <div *ngIf="TipoFuente=='CHV'" class="col-3">
                    <select class="form-select" aria-label="Default select example" name="trimestre" [disabled]="!Trimestre" [(ngModel)]="Consultar.trimestre">
                        <option  value="0" selected>Seleccione</option>
                        <option  value="1">Marzo</option>
                        <option  value="2">Junio</option>
                        <option  value="3">Septiembre</option>
                        <option  value="4">Diciembre</option>
                    </select>
                </div>
                <div *ngIf="TipoFuente=='FIVI'" class="col-3">
                  <select class="form-select" aria-label="Default select example" name="trimestre" [disabled]="!Trimestre" [(ngModel)]="Consultar.trimestre">
                      <option  value="0" selected>Seleccione</option>
                      <option  value="1">Enero</option>
                      <option  value="2">Febrero</option>
                      <option  value="3">Marzo</option>
                      <option  value="4">Abril</option>
                      <option  value="5">Mayo</option>
                      <option  value="6">Junio</option>
                      <option  value="7">Julio</option>
                      <option  value="8">Agosto</option>
                      <option  value="9">Septiembre</option>
                      <option  value="10">Octubre</option>
                      <option  value="11">Noviembre</option>
                      <option  value="12">Diciembre</option>
                  </select>
              </div>
            </div>
            <br>
            <div *ngIf="!BtnDescarga" class="container" style="text-align: center;">
                <button class="btn btn-secondary" (click)="consultarHistorico()">Buscar</button>
            </div>
            <div *ngIf="BtnDescarga">
                <div class="row justify-content-center" style="text-align: center;">
                    <button class="btn btn-secondary col-auto" (click)="consultarHistorico()" style="margin: 2px;">Buscar</button>
                    <button *ngIf="TipoFuente=='CHV'" class="btn btn-primary col-auto" (click)="downloadChv()" style="margin: 2px;">Descargar <i class="fas fa-download"></i></button>
                    <button *ngIf="TipoFuente=='FIVI'" class="btn btn-primary col-auto" (click)="downloadFivi()" style="margin: 2px;">Descargar <i class="fas fa-download"></i></button>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row justify-content-center">

        </div>
    </div>
</body>

<table class="table table-bordered" id="ConsultaChv" style="margin: auto; display: none;">
  <thead style="background-color: lightgray;">
    <tr>
      <th class="text-center">Consecutivo</th>
      <th class="text-center">Anio</th>
      <th class="text-center">Trimestre</th>
      <th class="text-center">Tipo de crédito</th>
      <th class="text-center">Departamento</th>
      <th class="text-center">Municipio</th>
      <th class="text-center">Solución Vivienda</th>
      <th class="text-center">Tenedor</th>
      <th class="text-center">Moneda</th>
      <th class="text-center">Rango vivienda</th>
      <th class="text-center">Mora</th>
      <th class="text-center">Número créditos</th>
      <th class="text-center">Saldo capital total</th>
      <th class="text-center">Capital uno o mas cuotas vencidas</th>
      <th class="text-center">Tasa</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let R of ResultadoConsulta">
      <td scope="col" style="text-align: center;">{{R.consecutivo}}</td>
      <td scope="col" style="text-align: center;">{{R.anio}}</td>
      <td scope="col" style="text-align: center;">{{R.trimestre}}</td>
      <td scope="col" style="text-align: center;">{{R.tipo_de_credito}}</td>
      <td scope="col" style="text-align: center;">{{R.departamento}}</td>
      <td scope="col" style="text-align: center;">{{R.municipio}}</td>
      <td scope="col" style="text-align: center;">{{R.solucion_vivienda}}</td>
      <td scope="col" style="text-align: center;">{{R.tenedor}}</td>
      <td scope="col" style="text-align: center;">{{R.moneda}}</td>
      <td scope="col" style="text-align: center;">{{R.rango_vivienda}}</td>
      <td scope="col" style="text-align: center;">{{R.mora}}</td>
      <td scope="col" style="text-align: center;">{{R.numero_creditos}}</td>
      <td scope="col" style="text-align: center;">{{R.saldo_capital_total}}</td>
      <td scope="col" style="text-align: center;">{{R.capital_una_mas_cuotas_vencidad}}</td>
      <td scope="col" style="text-align: center;">{{R.tasa}}</td>
    </tr>
  </tbody>
</table>

<table class="table table-bordered" id="ConsultaFivi" style="margin: auto; display: none;">
  <thead style="background-color: lightgray;">
    <tr>
      <th class="text-center">Consecutivo</th>
      <th class="text-center">Anio</th>
      <th class="text-center">Mes</th>
      <th class="text-center">Operación Financiera</th>
      <th class="text-center">Sexo Titular</th>
      <th class="text-center">Edad Titular</th>
      <th class="text-center">Destino Crédito</th>
      <th class="text-center">Solución Vivienda</th>
      <th class="text-center">Destino Crédito Vivienda</th>
      <th class="text-center">Destino Crédito Construcción</th>
      <th class="text-center">Departamento</th>
      <th class="text-center">Municipio</th>
      <th class="text-center">Departamento Vivienda</th>
      <th class="text-center">Municipio Vivienda</th>
      <th class="text-center">Subsidio</th>
      <th class="text-center">Tipo Subsidio</th>
      <th class="text-center">Moneda</th>
      <th class="text-center">Rango Vivienda</th>
      <th class="text-center">Número Créditos</th>
      <th class="text-center">Valor Avaluo</th>
      <th class="text-center">Número Desembolsos</th>
      <th class="text-center">Valor Crédito</th>
      <th class="text-center">Plazo Crédito</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let R of ResultadoConsulta">
      <td scope="col" style="text-align: center;">{{R.consecutivo}}</td>
      <td scope="col" style="text-align: center;">{{R.anio}}</td>
      <td scope="col" style="text-align: center;">{{R.mes}}</td>
      <td scope="col" style="text-align: center;">{{R.cod_oper_fin}}</td>
      <td scope="col" style="text-align: center;">{{R.sexo_TITULAR}}</td>
      <td scope="col" style="text-align: center;">{{R.edad_titular}}</td>
      <td scope="col" style="text-align: center;">{{R.des_cre}}</td>
      <td scope="col" style="text-align: center;">{{R.solu_viv}}</td>
      <td scope="col" style="text-align: center;">{{R.des_cre_vivi}}</td>
      <td scope="col" style="text-align: center;">{{R.des_cre_cons}}</td>
      <td scope="col" style="text-align: center;">{{R.depto}}</td>
      <td scope="col" style="text-align: center;">{{R.municipio}}</td>
      <td scope="col" style="text-align: center;">{{R.cod_dept_viv}}</td>
      <td scope="col" style="text-align: center;">{{R.cod_mun_viv}}</td>
      <td scope="col" style="text-align: center;">{{R.sub_sn}}</td>
      <td scope="col" style="text-align: center;">{{R.tip_sub}}</td>
      <td scope="col" style="text-align: center;">{{R.moneda}}</td>
      <td scope="col" style="text-align: center;">{{R.ran_viv}}</td>
      <td scope="col" style="text-align: center;">{{R.num_cred}}</td>
      <td scope="col" style="text-align: center;">{{R.val_avaluo}}</td>
      <td scope="col" style="text-align: center;">{{R.num_desem}}</td>
      <td scope="col" style="text-align: center;">{{R.val_cred}}</td>
      <td scope="col" style="text-align: center;">{{R.plaz_cred}}</td>
    </tr>
  </tbody>
</table>
